<script setup lang="ts">
import logoPrincipal from '@/assets/logo-principal.png'
import logoWhite from '@/assets/logo-white.png'
import simbolo from '@/assets/simbolo.png'

interface Props {
  variant?: 'default' | 'white' | 'dark'
  showSlogan?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  symbolOnly?: boolean
}

withDefaults(defineProps<Props>(), {
  variant: 'default',
  showSlogan: false,
  size: 'md',
  symbolOnly: false,
})

const sizeMap = {
  xs: { height: 'h-10', symbol: 'h-10 w-10' },
  sm: { height: 'h-16', symbol: 'h-16 w-16' },
  md: { height: 'h-24', symbol: 'h-24 w-24' },
  lg: { height: 'h-32', symbol: 'h-32 w-32' },
  xl: { height: 'h-40', symbol: 'h-40 w-40' },
}
</script>

<template>
  <div class="flex items-center">
    <img
      v-if="symbolOnly"
      :src="simbolo"
      alt="Ergonlider"
      :class="sizeMap[size].symbol"
    />
    <img
      v-else
      :src="variant === 'white' ? logoWhite : logoPrincipal"
      alt="Ergonlider"
      :class="[sizeMap[size].height, 'w-auto']"
    />
  </div>
</template>
